import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "sewer",
  "use": "sewer-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"sewer\"><path d=\"M10 1.3c4.5 0 8.2 3.4 8.6 7.9.4 4.8-3.1 9-7.9 9.4H10c-4.8 0-8.7-3.9-8.7-8.7S5.2 1.3 10 1.3M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10c0-3-1.3-5.8-3.6-7.7C14.6.8 12.3 0 10 0z\" /><path d=\"M3.437 4.744l.452-.534 13.206 11.176-.453.534zM1.221 7.903l.45-.536L14.074 17.79l-.45.536zM6.662 2.108l.451-.535 11.855 9.986-.451.536z\" /><path d=\"M3.8 17.6c-.1 0-.2 0-.3-.1l-.3-.9.6.2-.4-.4c0-.1.1-.2.3-.4C7.9 9.7 12 5.6 16 3.8l.5 1.2C14 6.1 9.8 9.1 4.6 16.8c-.3.4-.5.8-.8.8zm0-.7l.6.2-.6-.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sewer.svg
// module id = inSd
// module chunks = 1